/** Project the server's diagnostic health into the three customer states. */
export function channelHealthResult(control) {
    if (control?.enabled === false) return 'off';
    if (control?.enabled === true
        && control?.runtime_health === 'healthy'
        && !control?.runtime_health_stale) return 'passed';
    return 'failed';
}

/** Google Chat exposes two modes, but both currently use the same active
 * Workspace-user sender. Keep one operational truth and present it twice. */
export function googleChatModeResults(control) {
    const runtime = channelHealthResult(control);
    if (runtime === 'off') return { dcm: 'off', crm: 'off' };
    if (control?.dcm_defined === false) return { dcm: 'off', crm: 'off' };
    return { dcm: runtime, crm: runtime };
}

export const CHANNEL_HEALTH_LABELS = {
    off: 'Off',
    passed: 'Passed',
    failed: 'Failed',
};
